import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import { cn } from "@/lib/utils"

// Radix UI Tooltip Components
// Wrapper to set default delay duration (1000ms)
const TooltipProvider = ({ delayDuration = 1000, ...props }) => (
  <TooltipPrimitive.Provider delayDuration={delayDuration} {...props} />
)
TooltipProvider.displayName = "TooltipProvider"

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      "z-50 overflow-hidden rounded-md bg-[#8B00FF] px-3 py-1.5 text-sm text-gray-400 shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    )}
    style={{
      boxShadow: '0 0 20px rgba(139, 0, 255, 0.6), 0 4px 6px rgba(0, 0, 0, 0.3)'
    }}
    {...props}
  />
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

// Custom Tooltip Component (for backward compatibility)
const CustomTooltip = ({ children, text, position = 'top' }) => {
  const [isVisible, setIsVisible] = React.useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  return (
    <div 
      className="relative inline-block"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div 
          className={`
            absolute z-50 px-3 py-2 text-sm text-gray-400 whitespace-nowrap
            rounded-lg pointer-events-none
            animate-fade-in
            ${positionClasses[position]}
          `}
          style={{
            backgroundColor: '#8B00FF',
            boxShadow: '0 0 20px rgba(139, 0, 255, 0.6), 0 4px 6px rgba(0, 0, 0, 0.3)'
          }}
        >
          {text}
          {/* Tooltip arrow */}
          <div 
            className={`
              absolute w-2 h-2 rotate-45
              ${position === 'top' ? 'bottom-[-4px] left-1/2 -translate-x-1/2' : ''}
              ${position === 'bottom' ? 'top-[-4px] left-1/2 -translate-x-1/2' : ''}
              ${position === 'left' ? 'right-[-4px] top-1/2 -translate-y-1/2' : ''}
              ${position === 'right' ? 'left-[-4px] top-1/2 -translate-y-1/2' : ''}
            `}
            style={{ backgroundColor: '#8B00FF' }}
          />
        </div>
      )}
    </div>
  );
};

export { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent }
export default CustomTooltip;
